"use strict";
var NodeFetchClient = (function () {
    function NodeFetchClient(siteUrl, _clientId, _clientSecret, _realm) {
        if (_realm === void 0) { _realm = ""; }
        this.siteUrl = siteUrl;
        this._clientId = _clientId;
        this._clientSecret = _clientSecret;
        this._realm = _realm;
    }
    NodeFetchClient.prototype.fetch = function (url, options) {
        throw new Error("Using NodeFetchClient in the browser is not supported.");
    };
    return NodeFetchClient;
}());
exports.NodeFetchClient = NodeFetchClient;
